module.exports = __webpack_public_path__ + "static/media/paul@3x.5d73bb51.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/paul@3x.png
// module id = 220
// module chunks = 1